import { performRESTRequest } from "@ng-mw/framework-core"
import { GetProductsByCampaignIdResponse } from "../types/CampaignAdminTypes"
import { IMinimalProduct } from "@ng-mw/platform-interfaces"
import { mapGetProductsByCampaignIdResponseToIMinimalProduct } from "../helpers/mapGetProductsByCampaignIdResponseToIMinimalProduct"

/**
 * Get a list of products based on the storeId and campaignId.
 *
 * @param {string} storeId - The ID of the store (Example: 7080001271961).
 * @param {string | number} campaignId - The database ID of the campaign (Example: 18907).
 *
 * @returns {Promise<IMinimalProduct[]>} A promise that resolves to an array of products.
 */
export const getProductsByCampaignId = async (
    storeId: string,
    campaignId: string | number,
): Promise<IMinimalProduct[]> => {
    const campaignIdString = String(campaignId)

    const params = new URLSearchParams({
        page: "1",
        page_size: "20",
        full_response: "true",
        fieldset: "maximal",
        showNotForSale: "true",
        campaign_id: campaignIdString,
    })

    const response = await performRESTRequest({
        method: "GET",
        path: `/api/products/{chainid}/${storeId}?${params.toString()}`,
    })

    if (!Array.isArray(response?.hits?.hits)) {
        throw new TypeError(
            "Malformed response from REST: Missing required array as hits property.",
        )
    }

    const products = mapGetProductsByCampaignIdResponseToIMinimalProduct(
        response as GetProductsByCampaignIdResponse,
    )

    return products
}
